/* eslint-disable react-hooks/rules-of-hooks */
import { Heading } from '@chakra-ui/react';
import { FC } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainContent from '../../../components/Generic/MainContent';
import AdminMenuItem from '../components/AdminMenuItem';
import { componentsPageInfo } from './CmsComponents';
import { pageAdminInfo } from './CmsPages';
import { whitelistPageInfo } from './Whitelist';

const AdminPanelPage: FC = () => {
  const { path } = useRouteMatch();
  const { t } = useTranslation();
  const history = useHistory();
  const handleClickOptions = (data: { path: string }) => {
    history.push(`${data.path}`);
  };
  return (
    <MainContent maxH="100svh" overflowY="auto">
      <Heading mb="48px" color="#469BFF" fontFamily="Poppins">
        {t('adminTitlePanel')}
      </Heading>

      <AdminMenuItem
        description={componentsPageInfo.description}
        title={componentsPageInfo.title}
        path={`${path}/${componentsPageInfo.path}`}
        onClick={handleClickOptions}
      />
      <AdminMenuItem
        description={pageAdminInfo.description}
        title={pageAdminInfo.title}
        path={`${path}/${pageAdminInfo.path}`}
        onClick={handleClickOptions}
      />
      <AdminMenuItem
        description={whitelistPageInfo.description}
        title={whitelistPageInfo.title}
        path={`${path}/${whitelistPageInfo.path}`}
        onClick={handleClickOptions}
      />
    </MainContent>
  );
};

export default AdminPanelPage;
